import React from 'react';
import styles from './Button.module.css';

/**
 * Versatile button component mapping to the original CSS button variants.
 *
 * variant: 'primary' | 'outline' | 'sm-rose' | 'sm-outline' | 'sm-teal' | 'blue' | 'rose-full'
 * fullWidth: stretches to 100%
 * loading: shows spinner and disables the button
 */
function Button({
  variant = 'primary',
  fullWidth = false,
  onClick,
  children,
  type = 'button',
  disabled = false,
  loading = false
}) {
  const cls = [
    styles.btn,
    styles[variant] ?? '',
    fullWidth ? styles.fullWidth : '',
    loading ? styles.loading : '',
  ].join(' ').trim();

  return (
    <button
      type={type}
      className={cls}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading && (
        <span className={styles.spinner} aria-hidden="true"></span>
      )}
      <span className={loading ? styles.loadingText : ''}>{children}</span>
    </button>
  );
}

export default Button;
